import { render, staticRenderFns } from "./OrderCancelled.vue?vue&type=template&id=442c1163"
import script from "./OrderCancelled.vue?vue&type=script&lang=js"
export * from "./OrderCancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports